module.exports = __webpack_public_path__ + "img/arrow-square-left.34a34dee.svg";